import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property, state, query } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { when } from 'lit/directives/when.js';
import { emit } from '../../internal/event.js';
import { watch } from '../../internal/watch.js';
import { ARC_EVENTS } from '../../internal/constants/eventConstants.js';
import { ICON_TYPES } from '../icon/constants/IconConstants.js';
import styles from './arc-navbar.styles.js';
import { arupLogo } from './arup-logo.js';
import '../dropdown/arc-dropdown.js';
import '../icon-button/arc-icon-button.js';
import '../menu/arc-menu.js';
import '../menu-item/arc-menu-item.js';
export default class ArcNavbar extends LitElement {
    constructor() {
        super(...arguments);
        this.showDropdown = false;
        this.navTabs = [];
        this.tabs = 5;
        this.arup = true;
    }
    handleTabCountChange() {
        this._updateTemplate();
    }
    _handleTabChange(e) {
        const nodes = e.target.assignedElements({ flatten: true });
        this.navTabs = nodes.filter((el) => el.tagName === 'ARC-BUTTON' || el.tagName === 'ARC-ICON-BUTTON');
        this._updateTemplate();
    }
    _updateTemplate() {
        this.showDropdown = this.navTabs.length > this.tabs;
        [...this.navTabs].forEach(tab => {
            tab.style.display = this.showDropdown ? 'none' : 'initial';
        });
    }
    emitAccessibility() {
        emit(this, ARC_EVENTS.showAccessibility);
    }
    render() {
        const menuInterior = html `
      ${map(this.navTabs, tab => html `
          <arc-menu-item ?disabled="${tab.disabled}" @click="${() => tab.click()}">
            ${when(tab.name, () => html `<arc-icon .name=${tab.name} slot="prefix"> }</arc-icon>`)}
            ${tab.textContent || tab.label || tab.name || 'Invalid label'}
          </arc-menu-item>
        `)}
    `;
        const logoInterior = html `
      ${when(this.logo, () => html `<img id="tool-logo" src="${this.logo}" alt="tool-logo" />`)}
      <slot id="tool-name" name="name"></slot>
    `;
        return html `
      <header id="main">
        <div id="left">
          ${when(this.home, () => html `<a
              id="logoWrapper"
              href=${this.home}
              rel="noreferrer noopener"
              role="button"
              aria-label="tool logo"
            >
              ${logoInterior}
            </a>`, () => html `<div id="logoWrapper">${logoInterior}</div>`)}
        </div>
        <div id="right">
          <nav id="tabs" aria-label="primary navigation">
            <slot id="tabSlot" @slotchange=${this._handleTabChange}></slot>
            ${when(this.showDropdown, () => html `<arc-dropdown id="dropdown" hoist>
                <arc-icon-button slot="trigger" name=${ICON_TYPES.menu}></arc-icon-button>
                <arc-menu>${menuInterior}</arc-menu>
              </arc-dropdown>`)}
            <arc-icon-button
              id="accessibility"
              name=${ICON_TYPES.accessibility}
              label="Accessibility panel"
              @click=${this.emitAccessibility}
            ></arc-icon-button>
            <slot name="user"></slot>
          </nav>
          ${when(this.arup, () => html `<span id="company-logo">${arupLogo}</span>`)}
        </div>
      </header>
    `;
    }
}
ArcNavbar.tag = 'arc-navbar';
ArcNavbar.styles = styles;
__decorate([
    query('#tabSlot')
], ArcNavbar.prototype, "tabSlot", void 0);
__decorate([
    state()
], ArcNavbar.prototype, "showDropdown", void 0);
__decorate([
    state()
], ArcNavbar.prototype, "navTabs", void 0);
__decorate([
    property({ type: String })
], ArcNavbar.prototype, "home", void 0);
__decorate([
    property({ type: String })
], ArcNavbar.prototype, "logo", void 0);
__decorate([
    property({ type: Number, reflect: true })
], ArcNavbar.prototype, "tabs", void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true,
        converter: (attrValue) => (attrValue ? attrValue !== 'false' : true),
    })
], ArcNavbar.prototype, "arup", void 0);
__decorate([
    watch('tabs', { waitUntilFirstUpdate: true })
], ArcNavbar.prototype, "handleTabCountChange", null);
